import { withAuthRedirectToMain } from "../../hoc/AuthRedirectToMain";
import { connect } from "react-redux";
import { compose } from "redux";
import LandingPageController from "./landing-page-controller";
import {setNewPageNumber, signin, signup, resetPassword, setErrorInResetPassword, setErrorInRegistration, setErrorInLogin, setRegistrationIsSend} from "../../store/authorization"; 
import { setIsShowDemo, setIsDemoSuccess, sendMessage, setMenuActive } from "store/landing";
import { modalShowToggle } from "store/modal";
import { getValue } from "store/languages";

let mapStateToProps = (state) => {
    return {
        selectedLanguage: state.languages.selectedLanguage,
        activeMenu: state.LandingMenu.activeMenu,
        demoMenu: state.LandingMenu.demoMenu,
        demoContent: state.LandingMenu.demoContent,
        isShowDemo: state.LandingMenu.isShowDemo,
        errorInResetPassword: state.authorization.errorInResetPassword,
        errorInRegistration: state.authorization.registrationError,
        loginError: state.authorization.loginError,
        registrationIsSend: state.authorization.registrationIsSend,
        mediaBlocks: state.LandingMenu.mediaBlocks,
        advantagesMenu: state.LandingMenu.advantagesMenu,
        isDemoSuccess: state.LandingMenu.isDemoSuccess,
        situableBlocks: state.LandingMenu.situableBlocks,
        authLanguage: state.authorization.authLanguage
    }
}

const LandingPageContainer = compose(connect(mapStateToProps, {
    getValue,
    signin,
    setIsShowDemo,
    setIsDemoSuccess,
    modalShowToggle,
    sendMessage,
    setErrorInLogin,
    resetPassword,
    setMenuActive,
    setErrorInResetPassword
}),withAuthRedirectToMain)(LandingPageController);

export default LandingPageContainer;